import { arrayOf, Schema } from 'normalizr';

import { AFFILIATE_PROGRAM_SCHEMA } from '../../affiliateProgram/schemas';


export const CAMPAIGN_SCHEMA = new Schema(
  'campaigns'
);

CAMPAIGN_SCHEMA.define({
  affiliateProgram: AFFILIATE_PROGRAM_SCHEMA,
});

export const CAMPAIGNS_SCHEMA = {
  items: arrayOf(CAMPAIGN_SCHEMA),
};
